/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const WaterMarkPreviewDiv = styled.div`
  width: 270px;
  height: 350px;
  -webkit-box-shadow: 0px 0px 24px 0px rgb(0 0 0 / 25%);
  -moz-box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.25);
  box-shadow: 0px 0px 24px 0px rgb(0 0 0 / 25%);
  font-size: 12px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`

const WatermarkOuterDiv = styled.div`
  word-break: break-word;
`

const WatermarkInnerSpan = styled.span`
  display: block;
  transform-origin: 50% 50%;
  white-space: pre;
`

interface WatermarkData {
  stampText?: string
  foregroundColor?: string
  fontSize?: number
  opacity?: number
  rotateAngle?: number
  fontStyle?: number
  textAlignment?: number
  verticalAlignment?: number
  horizontalAlignment?: number
}

interface WatermarkPreviewProps {
  data: WatermarkData
}

const WatermarkPreview: React.FC<WatermarkPreviewProps> = ({ data }) => {
  const [cssClasses, setCssClasses] = useState('')
  const [styles1, setStyles1] = useState<React.CSSProperties>({})
  const [styles2, setStyles2] = useState<React.CSSProperties>({})

  useEffect(() => {
    const classes: string[] = []

    // Vertical alignment
    switch (data.verticalAlignment) {
      case 1:
        classes.push('align-top')
        break
      case 3:
        classes.push('align-bottom')
        break
    }

    // Horizontal alignment
    switch (data.horizontalAlignment) {
      case 1:
        classes.push('align-left')
        break
      case 3:
        classes.push('align-right')
        break
    }

    setCssClasses(classes.join(' '))

    const angle = -(data.rotateAngle || 0)
    const stylesOuter: React.CSSProperties = {}
    const stylesInner: React.CSSProperties = {
      color: data.foregroundColor || '#000000',
      fontSize: (data.fontSize || 8) * 0.5 + 'px',
      opacity: data.opacity ?? 0.5,
      WebkitTransform: `rotate(${angle}deg)`,
      MozTransform: `rotate(${angle}deg)`,
      msTransform: `rotate(${angle}deg)`,
      transform: `rotate(${angle}deg)`
    }

    // Font style
    switch (data.fontStyle) {
      case 0:
        stylesOuter.fontWeight = 'normal'
        stylesOuter.fontStyle = 'normal'
        break
      case 1:
        stylesOuter.fontWeight = 'bold'
        break
      case 2:
        stylesOuter.fontStyle = 'italic'
        break
      case 3:
        stylesOuter.fontWeight = 'bold'
        stylesOuter.fontStyle = 'italic'
        break
    }

    // Text alignment
    switch (data.textAlignment) {
      case 1:
        stylesOuter.textAlign = 'left'
        break
      case 2:
        stylesOuter.textAlign = 'center'
        break
      case 3:
        stylesOuter.textAlign = 'right'
        break
    }

    setStyles1(stylesOuter)
    setStyles2(stylesInner)
  }, [data])

  return (
    <WaterMarkPreviewDiv>
      <WatermarkOuterDiv className={cssClasses} style={styles1}>
        <WatermarkInnerSpan style={styles2}>{data.stampText}</WatermarkInnerSpan>
      </WatermarkOuterDiv>
    </WaterMarkPreviewDiv>
  )
}

export default WatermarkPreview
